module.exports = __webpack_public_path__ + "img/pdf.79b18012.jpg";